/* ============================================================================
 * oak-box-visualizer.js — RTA Wholesalers · White Oak Inset Shaker (Special Order)
 *
 * Two jobs, one pass over the same segmentation:
 *   1. replaces the flat orange placeholder "box" with the Premium Box finish,
 *   2. re-tints the OAK (doors, drawer fronts, face frame) to the stain the
 *      shopper selected, when one is selected — see the stain section below.
 *
 * Replaces the flat orange placeholder "box" in the oak product renders with
 * the approved PREMIUM BOX finish:
 *   base  SW 8917 Shell White   #F0EBE0
 *   grain SW 7573 Eaglet Beige  #E9D9C0   (seamless texture: premium-box-grain.jpg)
 * Doors, drawer fronts and face frame are left exactly as photographed.
 *
 * Self-gating per image — an image is only touched when it is a transparent
 * cabinet render that actually contains the orange box. Room photos, Snow White
 * photos, swatches, trim shots etc. are left alone. Any failure = original
 * photo stays (nothing can break the page).
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__oakBoxViz) return;
  window.__oakBoxViz = true;

  var CFG = window.OAK_BOX_CONFIG || {};
  var TEX_URL = CFG.textureUrl;
  if (!TEX_URL) return;
  // Never fight the painted-inset SW visualizer if it is active on this page.
  if (document.getElementById('rta-selection-bar')) return;

  var PDP_MAX = CFG.pdpMax || 1800;     // full-res for gallery + zoom
  var CARD_MAX = CFG.cardMax || 900;    // collection cards
  var SELECTORS_PDP = [
    '.product__media img',
    '.product-media-modal__content img',
    '.thumbnail-list img',
    '.product__media-item img'
  ].join(', ');
  var SELECTORS_CARD = [
    '#product-grid .card__media img',
    '.product-grid .card__media img',
    '.collection .card__media img'
  ].join(', ');

  /* ---------- premium-box texture (loaded once) ---------- */
  var texPromise = new Promise(function (resolve, reject) {
    var t = new Image();
    t.crossOrigin = 'anonymous';
    t.onload = function () {
      var c = document.createElement('canvas');
      c.width = t.naturalWidth; c.height = t.naturalHeight;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(t, 0, 0);
      resolve({ w: c.width, h: c.height, d: x.getImageData(0, 0, c.width, c.height).data });
    };
    t.onerror = reject;
    t.src = TEX_URL;
  });

  /* ---------- helpers ---------- */
  function baseKey(url) {                 // same photo regardless of width param
    return String(url || '').replace(/([?&])(width|height|crop)=[^&]*/g, '$1').replace(/[?&]+$/, '');
  }
  function sizedUrl(url, w) {
    var u = String(url);
    if (u.indexOf('//') === 0) u = location.protocol + u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function bestSrc(img) {
    return img.currentSrc || img.getAttribute('src') || img.src || '';
  }

  // mean over a (2R+1)x(2R+1) window, edge-clamped (integral image)
  function boxMean(src, W, H, R) {
    var S = new Float64Array((W + 1) * (H + 1)), out = new Float32Array(W * H), x, y;
    for (y = 0; y < H; y++) {
      var row = 0;
      for (x = 0; x < W; x++) { row += src[y * W + x]; S[(y + 1) * (W + 1) + x + 1] = S[y * (W + 1) + x + 1] + row; }
    }
    for (y = 0; y < H; y++) {
      var y0 = Math.max(0, y - R), y1 = Math.min(H, y + R + 1);
      for (x = 0; x < W; x++) {
        var x0 = Math.max(0, x - R), x1 = Math.min(W, x + R + 1);
        out[y * W + x] = (S[y1 * (W + 1) + x1] - S[y0 * (W + 1) + x1] - S[y1 * (W + 1) + x0] + S[y0 * (W + 1) + x0]) / ((y1 - y0) * (x1 - x0));
      }
    }
    return out;
  }

  // brightness-dependent saturation cut between orange placeholder and oak
  var TL = [0, 50, 75, 100, 125, 150, 175, 200, 256], TS = [0.60, 0.56, 0.55, 0.55, 0.555, 0.48, 0.42, 0.40, 0.38];
  function satThreshold(L) {
    for (var j = 1; j < TL.length; j++) if (L < TL[j]) return TS[j - 1] + (TS[j] - TS[j - 1]) * (L - TL[j - 1]) / (TL[j] - TL[j - 1]);
    return 0.38;
  }

  // flip 4-connected regions of value `val` smaller than `min` px
  // (val=1: remove specks; val=0: fill holes, only where `within` is set)
  function dropSmall(m, W, H, min, val, within) {
    var N = W * H, seen = new Uint8Array(N), stack = new Int32Array(N), region = new Int32Array(N);
    for (var s0 = 0; s0 < N; s0++) {
      if (seen[s0] || m[s0] !== val || (within && !within[s0])) continue;
      var sp = 0, n = 0; stack[sp++] = s0; seen[s0] = 1;
      while (sp) {
        var p = stack[--sp]; region[n++] = p; var px = p % W, nb;
        nb = p - 1; if (px > 0 && !seen[nb] && m[nb] === val && (!within || within[nb])) { seen[nb] = 1; stack[sp++] = nb; }
        nb = p + 1; if (px < W - 1 && !seen[nb] && m[nb] === val && (!within || within[nb])) { seen[nb] = 1; stack[sp++] = nb; }
        nb = p - W; if (p >= W && !seen[nb] && m[nb] === val && (!within || within[nb])) { seen[nb] = 1; stack[sp++] = nb; }
        nb = p + W; if (p < N - W && !seen[nb] && m[nb] === val && (!within || within[nb])) { seen[nb] = 1; stack[sp++] = nb; }
      }
      if (n < min) for (var q = 0; q < n; q++) m[region[q]] = 1 - val;
    }
  }

  /* ---------- stain ----------------------------------------------------
   * A stain is not a flat colour: it is the wood's own grain and shading seen
   * through a tint. So the photographed oak is not replaced, it is re-tinted —
   * every pixel keeps its luminance and its grain, and only the tone moves.
   *
   * The move is measured, not guessed. The same statistic (the lit face of the
   * wood: mean colour of the pixels around the 90th-percentile luminance) is
   * taken from the render's oak AND from the official swatch photo, and the
   * ratio between them is the correction. Pick the stain the render was
   * already shot in and the correction is 1:1 — the photo is left as it is.
   * -------------------------------------------------------------------- */
  function referenceTone(d, N, keep, lum) {
    var hist = new Uint32Array(256), cnt = 0, i, h;
    for (i = 0; i < N; i++) if (keep[i]) { hist[lum[i] | 0]++; cnt++; }
    if (cnt < 200) return null;                       // too little wood to measure
    var target = cnt * 0.9, acc = 0, Lref = -1;
    for (h = 0; h < 256; h++) { acc += hist[h]; if (acc >= target) { Lref = h; break; } }
    if (Lref < 0) return null;
    var lo = Lref - 8, hi = Lref + 8, r = 0, g = 0, b = 0, n = 0;
    for (i = 0; i < N; i++) {
      if (!keep[i] || lum[i] < lo || lum[i] > hi) continue;
      var k = i * 4; r += d[k]; g += d[k + 1]; b += d[k + 2]; n++;
    }
    if (!n) return null;
    return [r / n, g / n, b / n];
  }

  // The swatch photo's own tone, measured the same way. Cached per URL; a
  // swatch that will not load simply means no stain is applied.
  var swatchCache = {};
  function swatchTone(url) {
    if (swatchCache[url]) return swatchCache[url];
    swatchCache[url] = new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var W = 160, H = Math.max(1, Math.round(im.naturalHeight * (160 / im.naturalWidth)));
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, W, H);
          var d = x.getImageData(0, 0, W, H).data, N = W * H;
          var keep = new Uint8Array(N), lum = new Float32Array(N);
          for (var i = 0, k = 0; i < N; i++, k += 4) {
            var r = d[k], g = d[k + 1], b = d[k + 2];
            lum[i] = 0.299 * r + 0.587 * g + 0.114 * b;
            // the stained wood on the swatch, not its white surround or shadow
            if (d[k + 3] > 200 && r > g && g >= b && (r - b) / (r || 1) >= 0.10) keep[i] = 1;
          }
          resolve(referenceTone(d, N, keep, lum));
        } catch (e) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = url;
    });
    return swatchCache[url];
  }

  // The finish in force right now, as {code, swatch}, or null for "as shot".
  function currentFinish() {
    var f = window.OAK_FINISH_SELECTED;
    return f && f.swatch ? f : null;
  }

  /* ---------- core render: returns Promise<blob URL | null> ---------- */
  var cache = {};                          // baseKey|max|finish -> Promise
  function processUrl(src, max) {
    var fin = currentFinish();
    var key = baseKey(src) + '|' + max + '|' + (fin ? fin.code : '-');
    if (cache[key]) return cache[key];
    cache[key] = new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        Promise.all([texPromise, fin ? swatchTone(fin.swatch) : Promise.resolve(null)])
          .then(function (r) {
            try { resolve(render(im, r[0], max, r[1])); } catch (e) { resolve(null); }
          }, function () { resolve(null); });
      };
      im.onerror = function () { resolve(null); };
      im.src = sizedUrl(src, max);
    });
    return cache[key];
  }

  function render(im, tex, max, stainTone) {
    var iw = im.naturalWidth, ih = im.naturalHeight;
    var s = Math.min(1, max / Math.max(iw, ih));
    var W = Math.max(1, Math.round(iw * s)), H = Math.max(1, Math.round(ih * s)), N = W * H;
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(im, 0, 0, W, H);
    var img = cx.getImageData(0, 0, W, H), d = img.data;

    // 1) classify. The placeholder box is one flat orange material; oak is a
    //    much less saturated tan at every brightness. Box = orange hue with
    //    saturation above a brightness-dependent threshold (measured on the
    //    renders: dim box ~0.6-1.0 sat vs dim oak ~0.5; lit ~0.55 vs ~0.32).
    var box = new Uint8Array(N), lum = new Float32Array(N), solid = new Uint8Array(N), hueOk = new Uint8Array(N);
    var transparent = 0, opaque = 0, orange = 0, i, k, x, y;
    for (i = 0, k = 0; i < N; i++, k += 4) {
      var r = d[k], g = d[k + 1], b = d[k + 2], a = d[k + 3];
      var L = 0.299 * r + 0.587 * g + 0.114 * b;
      lum[i] = L;
      if (a < 10) transparent++;
      if (a === 0) continue;
      solid[i] = 1;
      if (a > 20) opaque++;
      if (!(r > g && g >= b)) continue;
      hueOk[i] = 1;
      var sat = (r - b) / r;                       // r is the max, b the min here
      if (L < 120 && g >= 0.70 * r) continue;      // dim oak is yellower than dim orange
      if (sat > satThreshold(L)) { box[i] = 1; if (a > 20) orange++; }
    }
    // gate: transparent render with >=5% orange box, or any image that is
    // >=12% orange box (older renders on a studio background)
    if (!opaque) return null;
    var of = orange / opaque;
    if (!((transparent / N >= 0.05 && of >= 0.05) || of >= 0.12)) return null;

    // 2) clean-up
    //  a) drop tiny box specks sitting in oak
    dropSmall(box, W, H, 40, 1, null);
    //  b) dim, low-contrast corners of the box interior can drift toward
    //     oak colour, but they stay perfectly smooth while oak always shows
    //     grain: flood from the box through smooth orange-hue pixels
    var det = new Float32Array(N), m3 = boxMean(lum, W, H, 1);
    for (i = 0; i < N; i++) det[i] = Math.abs(lum[i] - m3[i]);
    var grn = boxMean(det, W, H, 3);
    var stack = new Int32Array(N), sp = 0;
    for (i = 0; i < N; i++) if (box[i]) stack[sp++] = i;
    function floodTo(q) {
      if (q >= 0 && q < N && !box[q] && hueOk[q] && grn[q] < 0.7) { box[q] = 1; stack[sp++] = q; }
    }
    while (sp) {
      var p = stack[--sp], px = p % W;
      if (px > 0) floodTo(p - 1);
      if (px < W - 1) floodTo(p + 1);
      floodTo(p - W); floodTo(p + W);
    }
    //  c) fill tiny oak-coloured specks inside the box
    dropSmall(box, W, H, 40, 0, solid);

    // 2d) the oak itself: opaque, not box, and warm enough to be wood. The
    //     saturation floor is what keeps a white studio background, a grey
    //     shadow or a chrome pull from being stained along with the doors.
    var oak = null;
    if (stainTone) {
      oak = new Uint8Array(N);
      var oakN = 0;
      for (i = 0, k = 0; i < N; i++, k += 4) {
        if (box[i] || !solid[i] || d[k + 3] < 200) continue;
        var orr = d[k], og = d[k + 1], ob = d[k + 2];
        if (!(orr > og && og >= ob)) continue;
        if ((orr - ob) / (orr || 1) < 0.10) continue;
        oak[i] = 1; oakN++;
      }
      if (oakN < 200) oak = null;                  // nothing worth tinting
    }

    // 3) lighting reference = 90th percentile luminance of the box
    var hist = new Uint32Array(256), cnt = 0, h;
    for (i = 0; i < N; i++) if (box[i] && d[i * 4 + 3] > 200) { hist[lum[i] | 0]++; cnt++; }
    var target = cnt * 0.9, acc = 0, Lref = 150;
    for (h = 0; h < 256; h++) { acc += hist[h]; if (acc >= target) { Lref = h || 1; break; } }

    // 4) paint premium box: seamless grain texture, lit by the render's own shading
    var sc = Math.max(1, W / 1400), td = tex.d, tw = tex.w, th = tex.h;
    var WR = 1.0, WG = 0.90, WB = 0.74;          // warm shadows (no grey interiors)
    for (y = 0; y < H; y++) {
      var ty = ((y / sc) | 0) % th;
      for (x = 0; x < W; x++) {
        i = y * W + x;
        if (!box[i]) continue;
        k = i * 4;
        var tk = (ty * tw + (((x / sc) | 0) % tw)) * 4;
        var shade = lum[i] / Lref; if (shade > 1.1) shade = 1.1;
        var f = shade < 1 ? 0.40 + 0.60 * shade : shade;
        var fc = f < 1 ? f : 1;
        d[k]     = Math.min(255, td[tk]     * f * (WR + (1 - WR) * fc));
        d[k + 1] = Math.min(255, td[tk + 1] * f * (WG + (1 - WG) * fc));
        d[k + 2] = Math.min(255, td[tk + 2] * f * (WB + (1 - WB) * fc));
      }
    }
    // 5) re-tint the oak to the selected stain
    if (oak && stainTone) {
      var from = referenceTone(d, N, oak, lum);
      if (from) {
        var kr = stainTone[0] / (from[0] || 1),
            kg = stainTone[1] / (from[1] || 1),
            kb = stainTone[2] / (from[2] || 1);
        for (i = 0, k = 0; i < N; i++, k += 4) {
          if (!oak[i]) continue;
          var vr = d[k] * kr, vg = d[k + 1] * kg, vb = d[k + 2] * kb;
          d[k]     = vr > 255 ? 255 : vr;
          d[k + 1] = vg > 255 ? 255 : vg;
          d[k + 2] = vb > 255 ? 255 : vb;
        }
      }
    }

    cx.putImageData(img, 0, 0);
    return new Promise(function (res) {
      cv.toBlob(function (blob) { res(blob ? URL.createObjectURL(blob) : null); }, 'image/png');
    });
  }

  /* ---------- mounting ---------- */
  function apply(img, max) {
    if (!img || img.tagName !== 'IMG') return;
    var src = bestSrc(img);
    if (!src || src.indexOf('blob:') === 0 || src.indexOf('data:') === 0) return;
    // (re)apply — results are cached per photo, so a theme that reverts the src
    // simply gets the recolored version put back.
    img.dataset.oakBoxBase = baseKey(src);
    processUrl(src, max).then(function (url) {
      if (!url) return;
      if (img.dataset.oakBoxBase !== baseKey(src)) return;     // theme swapped the photo meanwhile
      var pic = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
      if (pic) pic.querySelectorAll('source').forEach(function (s) { s.removeAttribute('srcset'); });
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
      img.dataset.oakBox = '1';
    });
  }

  function scan(root) {
    root = root || document;
    root.querySelectorAll(SELECTORS_PDP).forEach(function (im) { apply(im, PDP_MAX); });
    var cards = root.querySelectorAll(SELECTORS_CARD);
    if (!('IntersectionObserver' in window)) { cards.forEach(function (im) { apply(im, CARD_MAX); }); return; }
    cards.forEach(function (im) { io.observe(im); });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); apply(e.target, CARD_MAX); } });
  }, { rootMargin: '400px' }) : null;

  function matchesAny(el, sel) { try { return el.matches(sel); } catch (e) { return false; } }

  function observe() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes') {
          var t = m.target;
          if (t.tagName !== 'IMG') return;
          var s = bestSrc(t);
          if (s.indexOf('blob:') === 0 || s.indexOf('data:') === 0) return;   // our own write
          if (matchesAny(t, SELECTORS_PDP)) apply(t, PDP_MAX);
          else if (matchesAny(t, SELECTORS_CARD)) apply(t, CARD_MAX);
          return;
        }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n.parentNode || n); });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  }

  // A finish change means every photo on the page has to be produced again;
  // results are cached per finish, so going back to one already seen is instant.
  function refresh() {
    document.querySelectorAll('img[data-oak-box-base]').forEach(function (im) {
      var base = im.dataset.oakBoxBase;
      if (!base) return;
      var max = matchesAny(im, SELECTORS_CARD) ? CARD_MAX : PDP_MAX;
      processUrl(base, max).then(function (url) {
        if (url) im.src = url;
      });
    });
  }
  window.OakBoxViz = { refresh: refresh };

  function boot() { scan(document); observe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
